import { DropdownButton, Image, NavLink, Nav } from 'react-bootstrap';
import NumericInput from 'react-numeric-input';
import styled from 'styled-components';

interface Props {
    decoration: string;
}

export const StyledTitle = styled.strong<Props>`
    font-size: 24px !important;
    font-weight: 700 !important;
    &:hover {
        text-decoration: ${(p) => p.decoration};
    }
`;

export const StyledSubtitle = styled.h6`
    font-size: 0.825rem !important;
    font-weight: 900 !important;
    color: #707070;
`;

export const StyledH4 = styled.h4`
    font-size: 20px !important;
`;

export const StyledH6 = styled.h6`
    font-size: 10px !important;
    color: white;
`;

export const StyledLinkSeller = styled(NavLink)`
    font-size: 13px !important;
    font-weight: bolder !important;
    color: white !important;

    :hover {
        text-decoration: underline;
        color: none !important;
    }
`;

export const StyledGreyRectangle = styled.div`
    border: 1px solid #bdbdbd;
    box-sizing: border-box;
    border-radius: 4px;
`;

export const StyledNav = styled(Nav)`
    padding: 15px;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 37px;
    margin-left: -15px !important;
`;

export const StyledTh = styled.th`
    background-color: #f2f2f2;
`;

export const StyledTr = styled.tr`
    background-color: #fbfbfb;
    font-weight: bolder;
`;

export const StyledTdText = styled.h5``;

export const StyledTdLink = styled.a`
    color: #212529;
    :hover {
        cursor: pointer !important;
        text-decoration: underline;
        color: #828282;
    }
`;

export const StyledDropdownButton = styled(DropdownButton)`
    //margin-left: -100px !important;
    Button {
        background-color: #ffffff;
        border-color: #ffffff;
    }
`;

export const StyledNumericInput = styled(NumericInput)`
    height: 30px !important;
    :focus {
        outline: none;
        border-color: #f2994a;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px #f2994a;
    }
    ~ b[style] {
        cursor: pointer !important;
    }
`;

export const StyledId = styled.h6`
    font-weight: normal;
    font-size: 14px;
    letter-spacing: 0.018em;
    color: #787885;
`;

export const StyledDesc = styled.h6`
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 150%;
    word-wrap: break-word;
    /* or 24px */
    letter-spacing: 0.0275em;
    /* Gray / 100 */
    color: #19191d;
`;

export const StyledPrice = styled.h6`
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 150%;
    /* identical to box height, or 36px */

    display: flex;
    align-items: center;

    /* Dark Color */

    color: rgba(0, 0, 0, 0.87);
`;

export const StyledText = styled.h6`
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 14px;
    /* or 140% */

    color: #707070;
`;

export const StyledDivider = styled.hr`
    margin-right: 2%;
    margin-left: 2%;
`;

export const StyledDetailValue = styled.h6`
    font-size: 2.5rem;
    font-weight: 700;
    @media (max-width: 991.98px) {
        font-size: 2rem;
        font-weight: 700;
    }
`;

export const StyledImage = styled(Image)`
    width: 80%;
    height: 80%;
    margin: 0 auto;
    &:hover {
        cursor: pointer;
    }
`;
